import { render } from "./NewCommonHeader.vue?vue&type=template&id=5630ccd7"
import script from "./NewCommonHeader.vue?vue&type=script&lang=js"
export * from "./NewCommonHeader.vue?vue&type=script&lang=js"

import "./NewCommonHeader.vue?vue&type=style&index=0&id=5630ccd7&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__